import React from 'react';
import classNames from 'classnames';

import css from './IconBillCheck.module.css';

/**
 * Add icon: "+"
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "add" icon
 */
const IconBillCheck = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.075 3.33337H27.925C29.8564 3.33337 30.8222 3.33337 31.601 3.60439C33.078 4.1183 34.2375 5.31202 34.7367 6.83248C35 7.63429 35 8.62846 35 10.6168V33.957C35 35.3874 33.3583 36.1464 32.3198 35.1961C31.7097 34.6377 30.7903 34.6377 30.1802 35.1961L29.375 35.9328C28.3057 36.9113 26.6943 36.9113 25.625 35.9328C24.5557 34.9543 22.9443 34.9543 21.875 35.9328C20.8057 36.9113 19.1943 36.9113 18.125 35.9328C17.0557 34.9543 15.4443 34.9543 14.375 35.9328C13.3057 36.9113 11.6943 36.9113 10.625 35.9328L9.81984 35.1961C9.20971 34.6377 8.29029 34.6377 7.68016 35.1961C6.64166 36.1464 5 35.3874 5 33.957V10.6168C5 8.62846 5 7.63429 5.26326 6.83248C5.76247 5.31202 6.92203 4.1183 8.39898 3.60439C9.17785 3.33337 10.1436 3.33337 12.075 3.33337ZM25.0991 14.1659C25.5589 13.6509 25.5141 12.8608 24.9992 12.401C24.4842 11.9412 23.694 11.9859 23.2342 12.5009L18.2143 18.1232L16.7658 16.5009C16.306 15.9859 15.5158 15.9412 15.0008 16.401C14.4859 16.8608 14.4411 17.6509 14.9009 18.1659L17.2819 20.8326C17.519 21.0982 17.8582 21.2501 18.2143 21.2501C18.5704 21.2501 18.9096 21.0982 19.1467 20.8326L25.0991 14.1659ZM12.5 24.5834C11.8096 24.5834 11.25 25.143 11.25 25.8334C11.25 26.5237 11.8096 27.0834 12.5 27.0834H27.5C28.1904 27.0834 28.75 26.5237 28.75 25.8334C28.75 25.143 28.1904 24.5834 27.5 24.5834H12.5Z"
        fill="#A9DBFB"
      />
    </svg>
  );
};

export default IconBillCheck;
